import { Box, useMediaQuery } from "@mui/material";
import { Outlet } from "react-router-dom";
import Sidebar from "./Sidebar";
import { useState } from "react";
import Header from "./Header";

import { useHookstate } from "@hookstate/core";
import { isProfileClickedState } from "../../hooks/store";
import ProfileDialog from "../../component/ProfileDialog";

const DashboardLayout = () => {
  const [isDrawerOpen, setDrawerOpen] = useState(false);
  const isMobile = useMediaQuery((theme) => theme.breakpoints.down("sm"));
  const profileHookState = useHookstate(isProfileClickedState);



  const handleDrawerToggle = () => {
    setDrawerOpen(!isDrawerOpen);
  };
  return (
    <Box>

      <Header isMobile={isMobile} onDrawerToggle={handleDrawerToggle} />
      <Sidebar
        isMobile={isMobile}
        isOpen={isDrawerOpen}
        onClose={handleDrawerToggle}
        onDrawerToggle={(close) => {
          setDrawerOpen(close);
        }}
      />
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          ml: { sm: `${isMobile ? 0 : 240}px` }, // adjust margin on desktop
          mt: 8,
        }}
      >
        <Outlet />
      </Box>

      {profileHookState.get().isClicked === true ? <ProfileDialog /> : null}
    </Box>
  );
};
export default DashboardLayout;
